// 休止中のモニタリングポイントを薄く表示するときの不透明度。
// 一覧側は FloorPlanItemList.vue の .floor-plan-item-list__item--inactive に
// 同じ値を CSS で持つ（CSS から JS 定数を参照できないため対で管理する）。
export const INACTIVE_OPACITY = 0.45;
